/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.6.24",
    versionName: "0.2.0-nightly.2025.6.24",
    versionChannel: "nightly",
    buildDate: "2025-06-24T00:09:07.153Z",
    commitHash: "e75618ac8b435914694defa150a2fa718eefb896",
};
